import { useUser } from '@/contexts/UserContext';
import { PlatformLink } from '@/types/ApiTypes';
import { useMemo } from 'react';
import { PAGE_CODES, LINK_CODES } from '@/constants/links.constants';

type LinkCode = typeof LINK_CODES[keyof typeof LINK_CODES];
type PageCode = typeof PAGE_CODES[keyof typeof PAGE_CODES];

type LinkQuery = {
    linkCode: LinkCode;
    pageCode: PageCode;
};

type MatchedLink = PlatformLink | null;

/**
 * Custom hook to retrieve matching platform links based on multiple linkCode and pageCode pairs.
 */
export const useLink = (queries: LinkQuery[]): MatchedLink[] => {
    const { platformLinks } = useUser();

    return useMemo(() => {
        if (!platformLinks) return queries.map(() => null);

        return queries.map(
            ({ linkCode, pageCode }) =>
                platformLinks.find((link: PlatformLink) => link.linkCode === linkCode && link.pageCode === pageCode) ||
                null
        );
    }, [platformLinks, JSON.stringify(queries)]);
};
